(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(649);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(5617);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./redux/slices/auth/thunk.ts
var thunk = __webpack_require__(9748);
// EXTERNAL MODULE: ./components/elements/Button/index.tsx
var Button = __webpack_require__(4340);
// EXTERNAL MODULE: ./api/config.ts
var config = __webpack_require__(3512);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(3918);
;// CONCATENATED MODULE: ./components/container/Login/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background:\n  linear-gradient(180deg, #FFD972 0%, rgba(255, 217, 114, 0) 100%), linear-gradient(180deg, rgba(232, 66, 68, 0.71) 26.22%, rgba(232, 66, 68, 0) 82.96%), #FFFFFF;\n\n  overflow-x: hidden;\n  overflow-y: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  margin-top: 1rem;\n  margin-left: 0.5rem;\n  height: min(3.8vw, 45px);\n  aspect-ratio: 16/9;\n  display: flex;\n  justify-content: center;\n\n  & img {\n    width: 50%;\n    height: 100%;\n  }\n\n  @media screen and (max-width: 1024px) {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 10;\n  transform: scale(0.6);\n  &.balloon-top {\n    transform: rotate(5deg) scale(0.6);\n    left: -144px;\n    top: -144px;\n  }\n  &.balloon-mid {\n    right: -80px;\n    top: 40%;\n  }\n  &.balloon-btm {\n    left: 10%;\n    top: 72.5%;\n  }\n  @media (min-width: 1024px) {\n    transform: scale(1);\n    &.balloon-top {\n      transform: scale(1);\n      left: 5%;\n      top: -150px;\n    }\n    &.balloon-mid {\n      right: 10%;\n      top: 20%;\n    }\n    &.balloon-btm {\n      left: 30%;\n      top: 55%;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (max-width: 576px) {\n    transform: scale(1.75);\n    bottom: 2rem;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var LoginWrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    className: "w-screen h-screen relative flex justify-center items-center"
})(_templateObject());
var Hero = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    className: "flex flex-col justify-center items-center z-20"
})(_templateObject1());
var Logo = styled_components_browser_esm/* default.img.attrs */.ZP.img.attrs({
    className: "mb-5 w-52 md:w-64"
})(_templateObject2());
var LogoWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
var Balloon = styled_components_browser_esm/* default.img */.ZP.img(_templateObject4());
var Mountains = styled_components_browser_esm/* default.img.attrs */.ZP.img.attrs({
    className: "absolute bottom-0 w-full"
})(_templateObject5());

;// CONCATENATED MODULE: ./components/container/Login/index.tsx









var Login = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var onLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ssoData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return popUpLogin();
                    case 2:
                        ssoData = _ctx.sent;
                        dispatch((0,thunk/* login */.x4)(ssoData));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onLogin() {
            return _ref.apply(this, arguments);
        };
    }();
    var popUpLogin = function() {
        var SSOWindow = window.open(new URL("/api/auth/login", config/* default */.Z).toString(), "SSO UI Login", "left=50, top=50, width=480, height=480");
        return new Promise(function(resolve, reject) {
            window.addEventListener("message", function(e) {
                try {
                    var data = JSON.parse(e.data);
                    resolve(data);
                    if (data.token && SSOWindow) {
                        SSOWindow.close();
                        window.removeEventListener("message", function() {
                            return null;
                        });
                    }
                } catch (error) {}
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Login | PMB 2022"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/pmb.svg",
                        alt: "pmb"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/ristek-purple.svg",
                        alt: "ristek"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                        src: "/images/pmb.svg",
                        alt: "pmb"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                        type: "primary",
                        onClick: onLogin,
                        children: "Log In with SSO"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balloon, {
                src: "/images/balloon-top.png",
                className: "balloon-top",
                alt: "balloon-top"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balloon, {
                src: "/images/balloon-mid.png",
                className: "balloon-mid",
                alt: "balloon-mid"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balloon, {
                src: "/images/balloon-btm.png",
                className: "balloon-btm",
                alt: "balloon-btm"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mountains, {
                src: "/images/bg-mountains.png",
                alt: "bg-mountains"
            })
        ]
    });
};
/* harmony default export */ var container_Login = (Login);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./redux/slices/auth/selector.ts + 2 modules
var selector = __webpack_require__(9004);
;// CONCATENATED MODULE: ./components/common/requireAnon.tsx
/* eslint-disable react/display-name */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ 




var requireAnon = function(WrappedComponent) {
    // @ts-ignore
    return function(props) {
        var user = (0,es/* useSelector */.v9)(selector/* getAuthUser */.nX);
        // checks whether we are on client / browser or server.
        if (true) {
            var Router = (0,router.useRouter)();
            var accessToken = localStorage.getItem("token");
            if (accessToken) {
                if ((user === null || user === void 0 ? void 0 : user.nama_panggilan) === null) {
                    Router.replace("/onboarding");
                } else {
                    Router.replace("/home");
                }
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props));
        }
        // If we are on server, return null
        return null;
    };
};
/* harmony default export */ var common_requireAnon = (requireAnon);

;// CONCATENATED MODULE: ./pages/index.tsx




var pages_Login = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container_Login, {});
};
/* harmony default export */ var pages = (common_requireAnon(pages_Login));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);